/* Elli aM — card colour-swatch preview.
   Click a swatch on a product/set card to swap that card's image to the colour's
   variant image (src + srcset from data attributes). Preview only — never navigates.
   Lightweight, delegated, no dependencies. */
(function () {
  function onActivate(sw) {
    var card = sw.closest('[data-elli-card]');
    var group = sw.closest('[data-elli-opt]');
    if (!card || !group) return;

    var sel = sw.getAttribute('data-target');
    var src = sw.getAttribute('data-img-src');
    if (sel && src) {
      var img = card.querySelector(sel);
      if (img) {
        if (!img.hasAttribute('data-elli-orig-src')) {
          img.setAttribute('data-elli-orig-src', img.getAttribute('src') || '');
          img.setAttribute('data-elli-orig-srcset', img.getAttribute('srcset') || '');
        }
        img.setAttribute('src', src);
        var ss = sw.getAttribute('data-img-srcset');
        if (ss) img.setAttribute('srcset', ss);
        img.setAttribute('loading', 'eager');
      }
    }

    var selected = group.querySelectorAll('.elli-opt__sw.is-selected');
    for (var i = 0; i < selected.length; i++) {
      selected[i].classList.remove('is-selected');
      selected[i].setAttribute('aria-pressed', 'false');
    }
    sw.classList.add('is-selected');
    sw.setAttribute('aria-pressed', 'true');
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.elli-opt__sw');
    if (!sw) return;
    e.preventDefault();
    onActivate(sw);
  });
})();
